import { spacing, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { smaller as smaller$1 } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-caption";
const smaller = objectWithClassName({
  ...smaller$1,
  color: color.gray.mediumAA,
  paddingTop: spacing.xs,
  className: [
    `${classNamePrefix}-smaller`,
    /** @deprecated Use 'umd-text-caption-smaller' instead */
    `umd-caption`
  ]
});
const smallerItalic = objectWithClassName({
  ...smaller,
  color: color.gray.darker,
  fontStyle: "italic",
  className: [
    `${classNamePrefix}-smaller-italic`,
    /** @deprecated Use 'umd-text-caption-smaller-italic' instead */
    `umd-forms-instructions`
  ]
});
export {
  smaller,
  smallerItalic
};
//# sourceMappingURL=caption.js.map
